export default class Constants{
    public static readonly ACCESS_TOKEN : string =  "Accesstoken";
    public static readonly USER_LOGGED_IN : string = "Userloggedin";
    public static readonly TOKEN_EXPIRATION_TIME : string = "Tokenexpirationtime";
    public static readonly REMEMBER_ME : string = "Rememberme";
    public static readonly User_Name : string = "Username";
    public static readonly PIPE_LINE : string = "PipeLine";
    public static readonly FILTER_ID : string = "FilterId";
    public static readonly Deal_FILTERS : string = "DealFilters";
    public static readonly USER_PROFILE : string = "UserProfile";
    public static readonly UTILITY : string = "Utility";
    public static readonly SIDEBAR_CLASS:string="SideBarClass";
    public static readonly ISSIDEBAR_EXPANDED:string="IsSideBarExpanded";
    public static readonly DEAL_EMAILS:string="DealEmails";
    public static readonly USER_Role : string = "sys_perm_data";
    public static readonly DOT_DIGITAL_CAMPAIGNSLIST : string = "DotDigitalCampaignList";
    public static readonly JUST_CALL_CAMPAIGNSLIST : string = "JustCallCampaignList";
    public static readonly EMAIL_TEMPLATES : string =  "EmailTemplates";
}